import { HttpErrorResponse } from '@angular/common/http';
import { DemoApiErrorBody } from './demo-api.types';

export class DemoApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
    readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'DemoApiError';
  }

  static disabled(): DemoApiError {
    return new DemoApiError(
      'DEMO_API_DISABLED',
      'La API demostrativa está deshabilitada.',
      0,
    );
  }

  static from(error: unknown): DemoApiError {
    if (error instanceof DemoApiError) return error;
    if (!(error instanceof HttpErrorResponse)) {
      return new DemoApiError(
        'DEMO_API_ERROR',
        'No fue posible consultar la API demostrativa.',
        0,
        error,
      );
    }

    const body = error.error as DemoApiErrorBody | undefined;
    return new DemoApiError(
      body?.error?.code ?? 'DEMO_API_HTTP_ERROR',
      body?.error?.message ?? 'No fue posible consultar la API demostrativa.',
      error.status,
      error,
    );
  }
}
